if (typeof ProvinceSelector !== "function") {
  const PROVINCE_SELECTOR_FORM_STORAGE_KEY = "PROVINCE_SELECTOR_FORM_STORAGE_KEY";
  const PROVINCE_SELECTOR_VIEWED_STORAGE_KEY = "PROVINCE_SELECTOR_VIEWED_STORAGE_KEY";

  class ProvinceSelector extends HTMLElement {
    constructor() {
      super();

      this.dropdown = document.querySelector("[data-js-province-selector-dropdown]");

      this.formData = {
        province: null,
        provinceCode: null,
        redirect: false,
      };

      this.init();
      this.listen();
    }

    init() {
      let checkoutRedirectProvincesJSONText = null;
      this.checkoutRedirectProvincesJSON = null;
      const checkoutRedirectProvincesJSONElem = this.querySelector("[type='application/json']");
      if (checkoutRedirectProvincesJSONElem) {
        checkoutRedirectProvincesJSONText = checkoutRedirectProvincesJSONElem.innerHTML;
      }
      if (checkoutRedirectProvincesJSONText) {
        this.checkoutRedirectProvincesJSON = JSON.parse(checkoutRedirectProvincesJSONText);
      }

      if (!this.checkoutRedirectProvincesJSON) return;

      this.getStoredProvinceSelectorData();
      this.initProvinceSelectorDropdown();
      if (!window.provinceSelector.viewed && !window.provinceSelector.formData) this.initProvinceSelectorPopup();
    }

    listen() {
      document.addEventListener("popup:provinceSelector:init", this.initProvinceSelectorPopup.bind(this));
      document.addEventListener(
        "popup:provinceSelector:complete",
        this.configureProvinceSelectorDropdownValue.bind(this)
      );
    }

    initProvinceSelectorDropdown() {
      new Shopify.CountryProvinceSelector("province_selector_dropdown_country", "province_selector_dropdown_province", {
        hideElement: "province_selector_dropdown_province_container",
      });

      this.dropdownInput = this.dropdown.querySelector("[name='province_selector[province]']");
      this.configureProvinceSelectorDropdownValue();
      this.dropdownInput.addEventListener("change", this.onProvinceSelectorDropdownSubmit.bind(this));
    }

    configureProvinceSelectorDropdownValue() {
      if (!this.dropdownInput) return;
      if (window.provinceSelector.formData?.province) {
        this.dropdownInput.value = window.provinceSelector.formData?.province;
      }
    }

    async onProvinceSelectorDropdownSubmit() {
      this.formData.province = this.dropdownInput.value;
      this.formData.provinceCode = this.dropdownInput[this.dropdownInput.selectedIndex].text;

      const found = this.checkoutRedirectProvincesJSON.find((province) => province === this.formData.province);
      this.formData.redirect = found ? true : false;

      this.storeProvinceSelectorData();

      document.querySelector("#overlay").style.display = "block";

      const checkoutButton = document.querySelector("checkout-button");
      checkoutButton.style.opacity = "0.5";
      checkoutButton.style.pointerEvents = "none";

      console.log("checkoutButton", checkoutButton);

      if (window?.locationId) {
        await fetch("https://qual-prd.api.sultans.co/companies/pricelist", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ location: `${window?.locationId}`, province: this.formData.provinceCode ?? "" }),
          redirect: "follow",
        });

        const cart = await fetch("/cart.js").then((res) => res.json());
        const items = cart.items.map((item) => ({ id: item.id, quantity: item.quantity }));

        // Clear the cart
        await fetch("/cart/clear.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        });

        // Add items back to the cart
        for (const item of items.reverse()) {
          await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ id: item.id, quantity: item.quantity }),
          });
        }
      }

      checkoutButton.style.opacity = "1";
      checkoutButton.style.pointerEvents = "auto";

      location.reload();
    }

    initProvinceSelectorPopup() {
      fetch(`?section_id=helper-province-selector-popup`)
        .then((response) => response.text())
        .then((text) => this._renderProvinceSelectorPopup(text))
        .catch((e) => console.log(e));
    }

    async onProvinceSelectorPopupSubmit(evt) {
      this.submit = evt.currentTarget;
      this.submit.classList.add("working");

      this.popupInput = this.provinceSelectorPopupModal.querySelector("[name='province_selector[province]']");
      this.formData.province = this.popupInput.value;

      const provinceMap = {
        Alberta: "AB",
        "British Columbia": "BC",
        Manitoba: "MB",
        "New Brunswick": "NB",
        "Newfoundland and Labrador": "NL",
        "Northwest Territories": "NT",
        "Nova Scotia": "NS",
        Nunavut: "NU",
        Ontario: "ON",
        "Prince Edward Island": "PE",
        Quebec: "QC",
        Saskatchewan: "SK",
        Yukon: "YT",
      };

      this.formData.provinceCode =
        provinceMap[this.popupInput.value] || this.popupInput[this.popupInput.selectedIndex].text;

      if (window?.locationId) {
        document.querySelector("#overlay").style.display = "block";

        const checkoutButton = document.querySelector("checkout-button");
        checkoutButton.style.opacity = "0.5";
        checkoutButton.style.pointerEvents = "none";

        console.log("checkoutButton", checkoutButton);

        await fetch("https://qual-prd.api.sultans.co/companies/pricelist", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ location: `${window?.locationId}`, province: this.formData.provinceCode ?? "" }),
          redirect: "follow",
        });

        const cart = await fetch("/cart.js").then((res) => res.json());
        const items = cart.items.map((item) => ({ id: item.id, quantity: item.quantity }));

        // Clear the cart
        await fetch("/cart/clear.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        });

        // Add items back to the cart
        for (const item of items.reverse()) {
          await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ id: item.id, quantity: item.quantity }),
          });
        }

        checkoutButton.style.opacity = "1";
        checkoutButton.style.pointerEvents = "auto";

        location.reload();
      }

      const found = this.checkoutRedirectProvincesJSON.find((province) => province === this.formData.province);
      this.formData.redirect = found ? true : false;

      this.storeProvinceSelectorViewed();
      this.storeProvinceSelectorData();

      setTimeout(() => {
        this.submit.classList.remove("working");
        this.provinceSelectorPopupModal.hide();

        document.dispatchEvent(new CustomEvent("popup:provinceSelector:complete"));
      }, 1000);
    }

    getStoredProvinceSelectorData() {
      const storedFormData = localStorage.getItem(PROVINCE_SELECTOR_FORM_STORAGE_KEY);
      const storedViewed = localStorage.getItem(PROVINCE_SELECTOR_VIEWED_STORAGE_KEY);
      const formData = JSON.parse(storedFormData);
      const viewed = JSON.parse(storedViewed);

      window.provinceSelector.formData = formData ? formData : null;
      window.provinceSelector.viewed = viewed ? viewed : false;
    }

    storeProvinceSelectorData() {
      const dataString = JSON.stringify(this.formData);

      localStorage.setItem(PROVINCE_SELECTOR_FORM_STORAGE_KEY, dataString);
      window.provinceSelector.formData = this.formData;
    }

    storeProvinceSelectorViewed() {
      const viewed = true;

      localStorage.setItem(PROVINCE_SELECTOR_VIEWED_STORAGE_KEY, viewed);
      window.provinceSelector.viewed = viewed;
    }

    _renderProvinceSelectorPopup(text) {
      const sectionInnerHTML = new DOMParser().parseFromString(text, "text/html");

      const existingProvinceSelectorPopupModals = document.querySelectorAll("[data-js-province-selector-popup-modal]");
      if (existingProvinceSelectorPopupModals.length)
        existingProvinceSelectorPopupModals.forEach((modal) => modal.remove());

      this.provinceSelectorPopupModal = null;

      // create modal w content

      const provinceSelectorPopupContainer = document.createElement("div");
      provinceSelectorPopupContainer.innerHTML = `<modal-box data-js-province-selector-popup-modal
        class="modal modal--province-selector" 
        data-options='{
          "enabled": false,
          "showOnce": false,
          "blockTabNavigation": true
        }'
        tabindex="-1" role="dialog" aria-modal="true" 
      >
        <div class="container--small">
          <div class="modal-content">
            <button class="modal-close" data-js-close data-js-first-focus style="position:absolute;margin:0;top:0;right:0">${window.KROWN.settings.symbols.close}</button>
          </div>
        </div>
        <span class="modal-background" data-js-close></span>
      </modal-box>`;

      this.provinceSelectorPopupModal = provinceSelectorPopupContainer.querySelector("modal-box");
      document.body.appendChild(this.provinceSelectorPopupModal);

      this.provinceSelectorPopupModal.querySelector(".modal-content").innerHTML =
        sectionInnerHTML.querySelector("#province-selector-popup").innerHTML;

      new Shopify.CountryProvinceSelector("province_selector_popup_country", "province_selector_popup_province", {
        hideElement: "province_selector_popup_province_container",
      });

      this.provinceSelectorPopupModal
        .querySelector("[data-js-province-selector-popup-submit]")
        .addEventListener("click", this.onProvinceSelectorPopupSubmit.bind(this));

      this.provinceSelectorPopupModal.querySelectorAll("[data-js-province-selector-popup-close]").forEach((button) => {
        button.addEventListener("click", () => {
          this.provinceSelectorPopupModal.hide();
          this.storeProvinceSelectorViewed();
        });
      });

      setTimeout(() => {
        this.provinceSelectorPopupModal.show();
      }, 250);
    }
  }

  if (typeof customElements.get("province-selector") == "undefined") {
    customElements.define("province-selector", ProvinceSelector);
  }
}

if (typeof CheckoutButton !== "function") {
  class CheckoutButton extends HTMLElement {
    constructor() {
      super();

      this.localeParam = KROWN.settings.locale !== "en" ? `/${KROWN.settings.locale}` : "";
      this.checkoutUrl = `${this.localeParam}/checkout`;

      this.externalPermalink = this.getAttribute("data-cart-external-permalink");

      this.provinceSelectorPopupTriggered = false;

      this.debouncedOnSubmit = debounce(() => {
        if (this.provinceSelectorPopupTriggered) {
          this.onSubmit();
          this.provinceSelectorPopupTriggered = false;
        }
      }, 500);

      this.listen();
    }

    listen() {
      this.addEventListener("click", this.onSubmit.bind(this));
      document.addEventListener("popup:provinceSelector:complete", this.debouncedOnSubmit.bind(this));
    }

    async onSubmit() {
      if (window.provinceSelector.formData) {
        if (window.locationId) {
          document.querySelector("#overlay").style.display = "block";

          const cart = await fetch("/cart.js").then((res) => res.json());
          const discountAllocations = cart.items.map((item) => item.line_level_discount_allocations);
          const discountAllocationsString = JSON.stringify(discountAllocations);

          const b2bPriceEnabled = discountAllocationsString.includes("Pricelist");
          if (b2bPriceEnabled) {
            const currentLocation = await fetch(
              `https://qual-prd.api.sultans.co/companies/pricelist?location=${window.locationId}`
            )
              .then((res) => res.json())
              .catch((e) => console.log(e));

            console.log("currentLocation", currentLocation);
            if (currentLocation && currentLocation?.pricelist) {
              const validPricelist = discountAllocationsString.includes(currentLocation.pricelist);
              console.log(validPricelist);
              if (!validPricelist) {
                localStorage.removeItem("PROVINCE_SELECTOR_VIEWED_STORAGE_KEY");
                localStorage.removeItem("PROVINCE_SELECTOR_FORM_STORAGE_KEY");
                this.provinceSelectorPopupTriggered = false;
                location.reload();
                return;
              }
            }
          }
        }

        if (window.provinceSelector.formData?.redirect) {
          document.querySelector("#overlay").style.display = "block";
          console.log("redirecting to far-met");
          console.log({
            customerId: window.customerId,
            locationId: window.locationId,
          });

          const cart = await fetch("/cart.js").then((res) => res.json());
          await fetch("https://qual-prd.api.sultans.co/farmet/checkout", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ customerId, locationId, cart }),
          })
            .then((res) => res.json())
            .then((res) => {
              console.log(res);
              window.location.href = res.checkoutUrl;
            })
            .catch((e) => console.log(e));
        } else {
          if (window?.customer) {
            const url = new URL(`${window.location.origin}${this.checkoutUrl}`);
            
            // Add all available customer attributes to the URL
            const attributes = {
              phone: window.customer?.phone,
              address1: window.customer?.address1,
              address2: window.customer?.address2,
              city: window.customer?.city,
              province: window.customer?.province,
              province_code: window.customer?.province_code,
              country: window.customer?.country,
              country_code: window.customer?.country_code,
              zip: window.customer?.zip,
              company: window.customer?.company,
              first_name: window.customer?.first_name,
              last_name: window.customer?.last_name,
              email: window.customer?.email
            };

            // Only append attributes that exist
            for (const [key, value] of Object.entries(attributes)) {
              if (value) {
                url.searchParams.append(`attributes[${key}]`, value);
              }
            }

            console.log(url.toString());

            window.location.href = url.toString();
            return;
          }

          window.location.href = this.checkoutUrl;
        }
      } else {
        this.provinceSelectorPopupTriggered = true;
        document.dispatchEvent(new CustomEvent("popup:provinceSelector:init"));
      }
    }
  }

  if (typeof customElements.get("checkout-button") == "undefined") {
    customElements.define("checkout-button", CheckoutButton);
  }
}
